/**
 * Path + query for `GET api/manpowers/hire-date` (ManpowersController.GetHireDate).
 * The server binds `employeeId`, `prospectId` and `PRCo`; a missing id is left out
 * rather than sent as the text "undefined"/"null", which would fail Guid binding.
 * Bug 37232: the prospect id used to go out as `profileId`, which the server ignored.
 */
export function buildHireDateUrl(
  employeeId: unknown,
  prospectId: unknown,
  prco: unknown
): string {
  const params = new URLSearchParams();
  if (employeeId) params.set('employeeId', `${employeeId}`);
  if (prospectId) params.set('prospectId', `${prospectId}`);
  params.set('PRCo', `${prco}`);
  return `/api/manpowers/hire-date/?${params.toString()}`;
}
